import React from 'react'
import {
  SelectTestFormValues,
  TestSessionFormValues,
  useLocationTestProducts,
  User_user_Address,
  UserFormValues,
  useInsuranceByUser,
  InsuranceFormValues,
  useAuth,
  getSubscriberName,
} from '@modmd/data'
import { FormikProps } from 'formik'
import { Text } from 'components/Typography'
import { UserInfo } from 'components/UserInfo'
import { Box } from 'components/Layout'
import { COLOR } from 'theme'
import { Divider } from 'sharedComponents/Divider'
import { format } from 'date-fns'

interface Props {
  labAddress?: Partial<User_user_Address> | null | undefined
  testSessionData: FormikProps<TestSessionFormValues>
  selectTestForm?: FormikProps<SelectTestFormValues>
  userForm?: FormikProps<UserFormValues>
  testLocationId?: string | null
  insuranceFormNewUser: FormikProps<InsuranceFormValues>
  isInsurance: boolean
}
export const DetailPayment: React.VFC<Props> = ({
  selectTestForm,
  testLocationId,
  insuranceFormNewUser,
  isInsurance,
}) => {
  const auth = useAuth()
  const insurance = useInsuranceByUser({
    userId: auth.data.User?.id || '',
  })

  const { products } = useLocationTestProducts({
    testLocationId: testLocationId ?? '1',
  })

  const productList = products.map((e) => e.Prices).flat()
  const orderedProductList: number[] = []
  productList.forEach((e) => {
    orderedProductList[Number(e.id)] = e.price
    return null
  })

  const finalAmount = selectTestForm?.values.tests
    .map((e) => orderedProductList[Number(e.priceId)] * e.quantity)
    ?.reduce((a, b) => a + b, 0)

  const insuranceData = insurance.data?.getInsuranceByUser ?? {
    ...insuranceFormNewUser?.values,
    id: '',
  }

  const subscriberName = getSubscriberName(
    insuranceData.subscriberFirstName,
    insuranceData.subscriberMiddleName,
    insuranceData.subscriberLastName
  )

  return (
    <Box>
      <Box my="1rem">
        <Text>Selected Tests</Text>
        <Divider />
      </Box>
      <Box display="flex" flexDirection="column" alignItems="start">
        {selectTestForm?.values?.tests.map((test) => {
          const product = products.find((item) => item.id === test.productId)
          return (
            <React.Fragment key={test.productId}>
              <Text>{product?.name}</Text>
              <Box display="flex" flexDirection="row" justifyContent="space-between" width="100%">
                <Text color={COLOR.grayDark} fontSize="xs" pl="1rem">
                  {!isInsurance && `$ ${orderedProductList[Number(test.priceId)]}`} x{' '}
                  {test.quantity}
                </Text>
                {!isInsurance && (
                  <Text color={COLOR.grayDark}>
                    $ {orderedProductList[Number(test.priceId)] * test.quantity}
                  </Text>
                )}
              </Box>
            </React.Fragment>
          )
        })}
      </Box>
      {!isInsurance && (
        <>
          <Divider />
          <Box display="flex" flexDirection="column" textAlign="end" alignItems="end" mt="1rem">
            <Text>Total: $ {finalAmount}</Text>
          </Box>
        </>
      )}

      {isInsurance && (
        <>
          <Box my="1rem" mt="3rem">
            <Text>Insurance Information</Text>
            <Divider />
          </Box>
          <UserInfo label="Insurance Company" text={insuranceData?.insuranceCompany} />
          <UserInfo label="Plan" text={insuranceData?.plan} />
          <UserInfo label="ID #" text={insuranceData?.cardID} />
          <UserInfo label="Group #" text={insuranceData.groupNumber} />
          <UserInfo label="Subscriber" text={subscriberName} />
          <UserInfo label="SSN" text={insuranceData.SSN} />
          <UserInfo label="Government-Issued Id Card #" text={insuranceData.driversLicense} />
          <UserInfo label="Relationship To Subscriber" text={insuranceData.relationToSubscriber} />
          {insuranceData.relationToSubscriber !== 'self' && (
            <>
              <UserInfo
                label="DOB"
                text={
                  insuranceData.subscriberDOB &&
                  format(new Date(insuranceData.subscriberDOB), 'MM/dd/yyyy')
                }
              />
              <UserInfo label="Gender" text={insuranceData.subscriberGender} />
            </>
          )}
        </>
      )}
    </Box>
  )
}
